import type { CitationDto } from '@/types/dto';

type Props = {
  label: string;
  sources: CitationDto[];
};

export function SourceList({ label, sources }: Props) {
  if (sources.length === 0) return null;
  return (
    <details className="mt-4 border-t border-border pt-2">
      <summary className="cursor-pointer font-(family-name:--font-ui) text-[0.7rem] uppercase tracking-[0.15em] text-muted py-1 hover:text-text min-h-8 flex items-center">
        {label} ({sources.length})
      </summary>
      <ul className="list-none pl-0 mt-2 space-y-1 text-sm">
        {sources.map((s) => {
          const num = s.id.startsWith('A') ? s.id.slice(1) : s.id;
          return (
            <li key={s.id} className="py-1 border-b border-border last:border-0 flex gap-2 items-baseline">
              <span className="font-(family-name:--font-ui) text-xs text-accent min-w-10">[{num}]</span>
              <span className="min-w-0">
                <a
                  href={s.sourceUrl}
                  target="_blank"
                  rel="noopener"
                  className="text-accent hover:underline break-words"
                >
                  {s.headline}
                </a>
                <span className="text-muted text-xs"> · {s.sourceName} · score {s.score}</span>
              </span>
            </li>
          );
        })}
      </ul>
    </details>
  );
}
